module.exports = __webpack_public_path__ + "static/photo_seb_2-b7cd51f2d921ff7636d0a43ffa3dc7fc.png";